import { privateApi } from 'services';
import {
    EndpointCompliance,
    ComplianceKyc,
    ComplianceUseCase,
    UpdateEndpointComplianceRequest,
    CreateComplianceKycRequest,
    CreateComplianceUseCaseRequest,
    CreatedComplianceResourceResponse,
} from './types';

const fetchEndpointCompliance = (businessAccountId: string, endpointId: string): Promise<EndpointCompliance> =>
    privateApi.get<EndpointCompliance>(
        `business-accounts/${businessAccountId}/bird/compliance/endpoints/${endpointId}`,
    );

const updateEndpointCompliance = (
    businessAccountId: string,
    endpointId: string,
    updateRequest: UpdateEndpointComplianceRequest,
): Promise<void> =>
    privateApi.put<void>(
        `business-accounts/${businessAccountId}/bird/compliance/endpoints/${endpointId}`,
        updateRequest,
    );

const fetchComplianceKyc = (businessAccountId: string, endpointId: string): Promise<ComplianceKyc[]> =>
    privateApi.get<ComplianceKyc[]>(
        `business-accounts/${businessAccountId}/bird/compliance/endpoints/${endpointId}/kyc`,
    );

const createComplianceKyc = (
    businessAccountId: string,
    endpointId: string,
    createRequest: CreateComplianceKycRequest,
): Promise<CreatedComplianceResourceResponse> =>
    privateApi.post<CreatedComplianceResourceResponse>(
        `business-accounts/${businessAccountId}/bird/compliance/endpoints/${endpointId}/kyc`,
        createRequest,
    );

const fetchComplianceUseCases = (businessAccountId: string): Promise<ComplianceUseCase[]> =>
    privateApi.get<ComplianceUseCase[]>(`business-accounts/${businessAccountId}/bird/compliance/use-cases`);

const createComplianceUseCase = (
    businessAccountId: string,
    createRequest: CreateComplianceUseCaseRequest,
): Promise<CreatedComplianceResourceResponse> =>
    privateApi.post<CreatedComplianceResourceResponse>(
        `business-accounts/${businessAccountId}/bird/compliance/use-cases`,
        createRequest,
    );

export const BirdComplianceGateway = {
    fetchEndpointCompliance,
    updateEndpointCompliance,
    fetchComplianceKyc,
    createComplianceKyc,
    fetchComplianceUseCases,
    createComplianceUseCase,
};
